/**
 * EditChapter Page
 * Wrapper that renders ChapterEditor in edit mode
 */
import { useParams } from "react-router-dom";
import { ChapterEditor } from "./ChapterEditor";

export default function EditChapter() {
  const { id: novelId, chapterId } = useParams<{
    id: string;
    chapterId: string;
  }>();

  if (!novelId || !chapterId) {
    return (
      <div className="text-center py-12">
        <p className="text-slate-600">Chapter not found.</p>
      </div>
    );
  }

  return <ChapterEditor mode="edit" novelId={novelId} chapterId={chapterId} />;
}
